
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-vouchers",
      function () {
        return require("private-next-pages/gift-vouchers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-vouchers"])
      });
    }
  